
export interface EvaluationsCoachingTrendData {
    score: number;
    rawScore: number;
    maxPossibleScore: number;
    // for coaching events this is when the coaching was completed {{CompletionTime: string;}}: they are the same field so i can sort them in the back end
    dateRecieved: string;
    agent: string;
    dateGroup: string;
    segmentContactID: string;
    segmentID: string;
    workflowInstanceID: string;
    workflowStatus: string;
    changeFormAllowed: boolean;
    scoringVisible: boolean;
    preferScoreOverRank: boolean;
    evaluationSubject: string;
    informationAccuracy?: string;
    dateDue?: string;
    assignee: string;
    assigneeStatus: string;
    assigner: string;
    coachingPackageName: string;
    coachingPlanId: string;
    coachingPlanName: string;
    dateAcknowledge: string;
    coachName: string;
    type: string;
    behavior: string;
};

export interface AgentDropdown {
    name: string;
    id: number;
    dtoID: number;
    selected: boolean;
    color: string;
    hasData: boolean;
}

export class AgentData {
    name: string;
    avgScore: AvgScoreInfo[] = [];
    scores: ScoresObj[] = [];
    coachings: CoachingObj[] = [];
    coachingPoint: CoachingPoint[] = [];
}

export interface AvgScoreInfo { // evalPoint
    date: string; // x
    avgScore: number; // y
    numEvals: number;
}

export interface CoachingPoint {
    x: number;
    y: number;
    numCoachings: string;
}

export interface ScoresObj {
    date: string;
    score: number;
    rawScore: number;
    maxPossibleScore: number;
    shortDate: string;
    segmentContactID: string;
    segmentID: string;
    workflowInstanceID: string;
    workflowStatus: string;
    changeFormAllowed: boolean;
    scoringVisible: boolean;
    preferScoreOverRank: boolean;
    evaluationSubject: string;
    informationAccuracy?: string;
    due?: string;
}

export interface CoachingObj {
    avgScore: number;
    coachingName: string;
    date: string;
    shortDate: string;
}

export interface PointObject {
    x: string | number;
    y: string | number;
    hasTooltip: boolean; // you can add custom data to a point object and reference it via series.chart.series.data
    dataLabels: [{ useHTML: boolean; format: string; color?: string; x?: number; y?: number }]; // this is an object that can be found from highcharts documentation
    marker: { symbol: string; width: number; height: number};  // this is an object that can be found from highcharts documentation
    className: string;
}

export interface NearestPointInfo {
    nearestPointAvg: number;
    idxOfNonNull: number;
}

export const StatusIcons = {
    "completed": "completed",
    "awaiting-acknowledgement": "awaiting-ack",
    "scheduled": "scheduled",
    "overdue": "overdue",
    "expired": "status-expired"
}

export const ChartUIPostionValues = {
     dataLabelYPosition: 12.2,
     dataLabelXPosition: -.5,
     markerRadius: 7,
     svgMarkerWidth: 50,
     svgMarkerHeight: 50,
     svgdataLabelXPosition: 19,
     svgdataLabelYPosition: -1
}
